<div class="relative isolate bg-white dark:bg-surface-950 px-6 py-12 sm:py-16 lg:px-8">
  <div class="mx-auto max-w-2xl text-center">
    <div class="text-center">
      <!-- Loading spinner -->
      @if (isPolling()) {
        <div class="mb-6">
          <p-progressSpinner animationDuration=".8s" fill="transparent" strokeWidth="4" styleClass="w-16 h-16" />
        </div>
      } @else {
        <div class="mb-6">
          <div class="h-16 w-16 bg-green-100 dark:bg-green-800 rounded-full flex items-center justify-center mx-auto">
            <i class="pi pi-check !text-2xl text-green-600 dark:text-green-400"></i>
          </div>
        </div>
      }

      <!-- Status message -->
      <h2 class="text-base/7 font-semibold text-primary mb-2">Payment Processing</h2>
      <p class="mt-2 text-3xl font-semibold tracking-tight text-balance sm:text-4xl mb-6">{{ statusMessage() }}</p>

      @if (isPolling()) {
        <p class="mx-auto mt-6 max-w-xl text-center text-lg font-medium text-pretty sm:text-xl/8 mb-8">
          Please wait while we confirm your payment with Stripe. This usually takes just a few seconds.
        </p>

        <!-- Countdown Panel -->
        <div class="mx-auto max-w-md">
          <p-panel>
            <div class="text-center">
              <p class="text-sm font-medium mb-2">Automatic redirect in:</p>
              <div class="text-2xl font-bold text-primary mb-2">{{ countdown() }}s</div>
              <p class="text-xs text-muted-color">You'll be redirected automatically if the payment isn't confirmed</p>
            </div>
          </p-panel>
        </div>
      } @else {
        <p class="text-lg font-medium">Your subscription has been activated successfully!</p>
      }
    </div>
  </div>
</div>
